import script from "./InfoSessionBookComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoSessionBookComponent.vue?vue&type=script&setup=true&lang=js"

import "./InfoSessionBookComponent.vue?vue&type=style&index=0&id=1451b38b&scoped=true&lang=css"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1451b38b"]])

export default __exports__